import $http from "../../axios";
import { Notification } from "element-ui";

export async function fetchSellers({commit, state}, text) {
  let params = { filter:text}
  console.log(new Date()+"Empezando Sellers");
  await $http.get('/api/lista-vendedores', {params} )
      .then((response) => {
          commit('setSellers', response.data.data)
      })
      .catch((error) => {
          Notification.error({
          title: 'Error!',
          message: error.message,
          type: 'error',
          duration: 1500,
          customClass: 'notification-box',
      });
  })
}

export async function getCommisionSaleBrand({ state, commit }, params) {
  state.params.date_from = params.date_from
  state.params.date_up = params.date_up
  state.params.seller_id = params.seller_id

  await $http.get("/api/consulta-comisiones-venta-marca", {params: state.params})
    .then(response => {
      commit('setCommisionSaleBrands', response.data) 
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.message,
        type: "error",
        duration: 2000,
        customClass: "notification-box"
      });
    });
  state.loading.commisionSaleBrands = false;
}



// WEBPACK FOOTER //
// ./src/modules/commission-sale-brand/actions.js